import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FilterEditor,
  FilterRecord,
  FilterSetupSource,
  FilterSetupSourceFn,
  Operator,
} from '@services/core-services/filters';
import { FilterService } from '@services/core-services/filters/filter.service';
import { Subscription } from 'rxjs';
import { CeFormFieldComponent } from '@enginuity/core/forms/form-field/form-field.component';
import { MatOption, MatSelect, MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-filter-entry-editor-list',
  imports: [CommonModule, CeFormFieldComponent, MatSelect, MatOption],
  templateUrl: './filter-entry-editor-list.component.html',
  styleUrl: './filter-entry-editor-list.component.scss',
})
export class FilterEntryEditorListComponent implements FilterEditor, OnDestroy {
  private _record!: FilterRecord;
  private subscription: Subscription | undefined;

  protected internalValue: string | string[] = '';

  get record(): FilterRecord {
    return this._record;
  }

  @Input()
  set record(record: FilterRecord) {
    this._record = record;
    this.setInternalValue(record);
    this.setOptions(record);
  }

  get multiselect(): boolean {
    return [Operator.In, Operator.NotIn].includes(this.record.rule.operator!);
  }

  get requiresValue(): boolean {
    return this.filter.requiresValue(this.record);
  }

  @Input() value: any | undefined;

  @Output() onChange: EventEmitter<string | string[]> = new EventEmitter<string | string[]>();
  @Output() onOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected options: { value: any; label: any }[] = [];

  constructor(private readonly filter: FilterService) {}

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  private setOptions(record: FilterRecord) {
    const { entry } = record;
    const source: FilterSetupSource | FilterSetupSourceFn | undefined = entry.source;
    const result = this.filter.getSourceOptions(source);
    this.subscription = result.subscribe(res => (this.options = res.map(this.toOptions)));
  }

  private toOptions(e: any) {
    return {
      value: e.key || e,
      label: e.value || e,
    };
  }

  onSelectionChange($event: MatSelectChange) {
    if (this.multiselect) this.handleMultiSelectChange($event);
    else this.handleSingleSelectChange($event);
  }

  handleOpenChange(flag: boolean) {
    this.onOpenChange.emit(flag);
  }

  private handleSingleSelectChange($event: MatSelectChange) {
    const value = $event.value;
    this.onChange.emit(value);
  }

  private handleMultiSelectChange($event: MatSelectChange) {
    const value: string[] = Array.isArray($event.value) ? $event.value : [$event.value];
    this.onChange.emit(value);
  }

  private setInternalValue(record: FilterRecord) {
    const value = record.rule.value;
    if (this.multiselect) {
      this.internalValue = Array.isArray(value) ? value : [value];
    } else {
      this.internalValue = value;
    }
  }
}
